const MARKETING_ATTRIBUTION_QUERY_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content', 'utm_id', 'utm_source_platform', 'utm_creative_format', 'utm_marketing_tactic', 'hsa_acc', 'hsa_cam', 'hsa_grp', 'hsa_ad', 'hsa_src', 'hsa_tgt', 'hsa_kw', 'hsa_mt', 'hsa_net', 'hsa_ver', 'gclid', 'gclsrc', 'gbraid', 'wbraid', 'dclid', 'gad_source', 'gad_campaignid', 'fbclid', 'li_fat_id', 'msclkid', 'ttclid', 'twclid', 'rdt_cid', 'epik', 'ScCid', 'sccid', 'irclickid', 'irgwc', 'mc_cid', 'mc_eid', 'mkt_tok', '_kx', 'adgroup', 'adgroupid', 'ad_group_id', 'ad_id', 'adset_id', 'campaign_id', 'creative', 'creative_id', 'keyword', 'matchtype', 'network', 'placement', 'device', 'ad_description', 'ref', 'referrer', 'referral', 'affiliate', 'partner'];

const MARKETING_ATTRIBUTION_QUERY_KEY_SET = new Set(MARKETING_ATTRIBUTION_QUERY_KEYS);

const toSearchParams = (search) => {
  if (search instanceof URLSearchParams) {
    return new URLSearchParams(search.toString());
  }

  const normalizedSearch = String(search || '');
  return new URLSearchParams(normalizedSearch.startsWith('?') ? normalizedSearch.slice(1) : normalizedSearch);
};

export const getMarketingAttributionSearchParams = (search = '') => {
  const sourceParams = toSearchParams(search);
  const attributionParams = new URLSearchParams();

  for (const [key, value] of sourceParams.entries()) {
    if (MARKETING_ATTRIBUTION_QUERY_KEY_SET.has(key) && String(value || '').trim()) {
      attributionParams.append(key, value);
    }
  }

  return attributionParams;
};

export const mergeMarketingAttributionSearchParams = ({ searchParams, sourceSearch } = {}) => {
  const mergedParams = getMarketingAttributionSearchParams(sourceSearch);
  const explicitParams = toSearchParams(searchParams);

  for (const [key, value] of explicitParams.entries()) {
    mergedParams.set(key, value);
  }

  return mergedParams;
};

export const getMarketingAttributionProperties = (search = '') => {
  return Object.fromEntries(getMarketingAttributionSearchParams(search).entries());
};

export const pickMarketingAttributionProperties = (value = {}) => {
  if (!value || typeof value !== 'object' || Array.isArray(value)) {
    return {};
  }

  return Object.fromEntries(
    Object.entries(value)
      .filter(([key, item]) => MARKETING_ATTRIBUTION_QUERY_KEY_SET.has(key) && String(item || '').trim())
      .map(([key, item]) => [key, String(item)])
  );
};

export const getInitialMarketingAttributionProperties = (search = '') => {
  const attributionProperties = getMarketingAttributionProperties(search);

  return Object.fromEntries(
    Object.entries(attributionProperties).map(([key, value]) => {
      return [`initial_${key}`, value];
    })
  );
};
